import { RQ_STALE_TIME_MS } from "../../types";

export function createQueryOptions<T, K extends T = T>(
  options: K
): Omit<K, "queryKey" | "queryFn"> {
  return {
    refetchOnWindowFocus: false,
    staleTime: RQ_STALE_TIME_MS,
    ...options,
  };
}
